import { useStaticQueryPrivacy } from "../../query/useStaticQueryPrivacy";
import { expandGlobalTokens } from "../../utils/globalTokens";
import classNames from "classnames";
import parse from "html-react-parser";
import React from "react";

/**
 * Variante di <Text> che, oltre a renderizzare l'HTML del popup, espande il
 * token globale @@privacy@@ con il testo completo configurato da WordPress
 * (ACF Options "Privacy").
 *
 * La sostituzione è testuale (vedi `expandGlobalTokens`): il token viene
 * rimpiazzato con l'HTML del testo e poi tutto viene parsato in un colpo solo.
 * Non si usa `removePTag`, così la struttura (paragrafi, titoli) del testo
 * iniettato resta intatta.
 */
function PopupText({ content, className = "" }) {
  const { privacy } = useStaticQueryPrivacy();

  if (!content || content.length === 0) {
    return null;
  }

  const html = expandGlobalTokens(content, { privacy });

  return <div className={classNames("editor", className)}>{parse(html)}</div>;
}

export default PopupText;
